/** Stable ids for mobile "pin to edge tab" on main draggable tool panels (MainPanel). */
export const MOBILE_TOOL_PANEL_PIN_IDS = {
  sceneGraph: "sceneGraph",
  sceneInventory: "sceneInventory",
  modelCheck: "modelCheck",
  massProperties: "massProperties",
  fileUpload: "fileUpload",
  poseEditor: "poseEditor",
  materialEditor: "materialEditor",
  lights: "lights",
  ikTarget: "ikTarget",
  runtimeControls: "runtimeControls",
  physics: "physics",
  actuators: "actuators",
  warmstart: "warmstart",
  behaviorEditor: "behaviorEditor",
  trainingPipeline: "trainingPipeline",
  octoTraining: "octoTraining",
  trainingMetrics: "trainingMetrics",
  policyRollout: "policyRollout",
  circleDetection: "circleDetection",
  measurements: "measurements",
  history: "history",
  assetStats: "assetStats",
  meshEditor: "meshEditor",
  xmlSource: "xmlSource",
  terrain: "terrain",
  objectLibrary: "objectLibrary",
  cameraProbe: "cameraProbe",
  sensors: "sensors",
} as const;

export type MobileToolPanelPinId =
  (typeof MOBILE_TOOL_PANEL_PIN_IDS)[keyof typeof MOBILE_TOOL_PANEL_PIN_IDS];
